import React from "react";
import {ReactComponent as MainteinanceLogo} from "./Mainteinance.svg"
// import "./Mainteinance.css"

function Mainteinance() {
  return (
    <>
    <MainteinanceLogo />
    <article>
      <h1>We&rsquo;ll be back soon!</h1>
      <div>
        <p>
          Sorry for the inconvenience. We&rsquo;re performing some maintenance
          at the moment. You can contact eboard support for updates, otherwise
          we&rsquo;ll be back up shortly!
        </p>
        <p>&mdash; The Software Technologies Ltd Team</p>
      </div>
    </article>
    </>
  );
}

export default Mainteinance;
